import React from 'react';
import { View, ScrollView, StyleSheet, SafeAreaView } from 'react-native';
import { Screens } from '../../constants/ScreenNames';
import Button, { BUTTON_TYPES } from '../Button';
import { useSelector, useDispatch } from 'react-redux';
import OptionNavigate from '../OptionNavigate';
import { CommonProperties, CommonStyles } from '../../styles';
import Images from '../../constants/Images';
import { formatCurrency } from '../../utils/currency.utils';
import { filterByVendor } from '../../store/actions/rail';
import { selectRailVendors } from '../../store/selectors/rail.selector';
import RowView from '../RowView';
import BaseText from '../BaseText';
import BottomButton from '../BottomButton';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import useTextRailFilter from '../../utils/useTextRailFilter';
import useTripFilters, { isAllChecked, tripFilters } from '../../utils/useTripFilters';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';

const RailFilterModal = ({ navigation }) => {
  const { tKey } = useComponentTKey('RailFilterModal');
  const { t } = useTranslation(i18nNS.rail);
  const dispatch = useDispatch();
  const railFilters = useSelector(selectRailVendors);
  const [disableButton, filters, dispatchFilters] = useTripFilters(railFilters);
  const [filtersMap] = useTextRailFilter();
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  return (
    <SafeAreaView style={CommonStyles.flex1}>
      <ScrollView style={[CommonStyles.flex1, CommonStyles.py3]}>
        {filters &&
          Object.entries(filters).map(([group, groupContent]) => {
            const isAllGroupChecked = isAllChecked(groupContent);

            return (
              <View key={group} style={CommonStyles.mb5}>
                <RowView
                  style={[
                    {
                      backgroundColor: 'white',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      paddingHorizontal: 12,
                    },
                  ]}
                >
                  <BaseText style={CommonStyles.h3}>{filtersMap[group].name}</BaseText>
                  <Button
                    style={{ maxWidth: 120, alignItems: 'flex-end', ...CommonProperties.px0 }}
                    type={BUTTON_TYPES.TEXT}
                    label={isAllGroupChecked ? t(tKey('ClearAll')) : t(tKey('CheckAll'))}
                    onPress={() => {
                      dispatchFilters({
                        type: tripFilters.CHECK_ALL,
                        group,
                        selected: !isAllGroupChecked,
                      });
                    }}
                  />
                </RowView>
                {Object.entries(groupContent)
                  .filter(([filter]) => filtersMap[filter])
                  .map(([filter, filterContent]) => (
                    <View key={filter}>
                      <BaseText style={styles.title}>{filtersMap[filter].name}</BaseText>
                      <View style={{ flex: 1, backgroundColor: 'white' }}>
                        {filterContent.count && (
                          <OptionNavigate
                            onPress={() => {
                              dispatchFilters({
                                type: tripFilters.CHECK_GROUP,
                                group,
                                filter,
                                selected: filterContent.checked,
                              });
                            }}
                            icon="flight"
                            title={filtersMap[filter].nameAsItem}
                            desc={filterContent.count + ' ' + t(tKey('StartingFrom'))}
                            price={formatCurrency(
                              filterContent.lowestPrice,
                              currency,
                              currencyCulture
                            )}
                            selected={filterContent.checked}
                          />
                        )}
                        {Object.entries(filterContent.items).map(([vendor, vendorContent]) => (
                          <OptionNavigate
                            key={vendor}
                            onPress={() => {
                              dispatchFilters({
                                type: tripFilters.CHECK,
                                group,
                                filter,
                                vendor,
                              });
                            }}
                            title={vendorContent.name}
                            image={
                              Images.rail['24x24'][vendor] ? Images.rail['24x24'][vendor] : null
                            }
                            desc={
                              vendorContent.count &&
                              vendorContent.count + ' ' + t(tKey('StartingFrom'))
                            }
                            price={formatCurrency(vendorContent.price, currency, currencyCulture)}
                            selected={vendorContent.checked}
                          />
                        ))}
                      </View>
                    </View>
                  ))}
              </View>
            );
          })}
      </ScrollView>
      <BottomButton
        onPress={() => {
          dispatch(filterByVendor(filters));
          navigation.navigate(Screens.Rail);
        }}
        label={t(tKey('Apply'))}
        disabled={disableButton}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  title: {
    ...CommonProperties.h3,
    ...CommonProperties.my2,
    ...CommonProperties.mx3,
  },
});

export default RailFilterModal;
